import { render, staticRenderFns } from "./breadcrumb-comp.vue?vue&type=template&id=0f746efe&scoped=true&class=pt-0&"
import script from "./breadcrumb-comp.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-comp.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumb-comp.vue?vue&type=style&index=0&id=0f746efe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f746efe",
  null
  
)

export default component.exports